import { Download, Loader2, X } from "lucide-react";
import { useState } from "react";

import { Button } from "@/components/ui";

interface Props {
  url: string;
  durationSeconds?: number | null;
  onClose: () => void;
  onDownload: (url: string) => Promise<void> | void;
}

export const VideoModal = ({ url, durationSeconds, onClose, onDownload }: Props) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownloadClick = async () => {
    if (isDownloading) return;
    setIsDownloading(true);
    await onDownload(url);
    setIsDownloading(false);
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-end justify-center bg-overlay backdrop-blur-sm sm:items-center"
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-lg sm:mx-4"
        onClick={(e) => e.stopPropagation()}
      >
        <Button
          size="icon"
          variant="secondary"
          onClick={onClose}
          className="absolute -top-5 right-0 z-10 rounded-full sm:-right-5"
        >
          <X />
        </Button>
        <video
          src={url}
          controls
          autoPlay
          playsInline
          className="w-full rounded-t-2xl shadow-2xl sm:rounded-2xl"
          style={{ maxHeight: "75vh" }}
        />
        <div className="flex items-center justify-between rounded-b-2xl bg-zinc-900 px-4 py-3 sm:mt-3 sm:rounded-none sm:bg-transparent sm:px-0 sm:py-0">
          <p className="text-sm text-white/70 sm:text-zinc-500">
            {durationSeconds ? `${durationSeconds}s` : ""}
          </p>
          <Button
            variant="secondary"
            className="text-black"
            onClick={handleDownloadClick}
            disabled={isDownloading}
          >
            {isDownloading ? <Loader2 className="animate-spin" /> : <Download />}
            {isDownloading ? "Downloading…" : "Download"}
          </Button>
        </div>
      </div>
    </div>
  );
};
